export default state => state.payment.adyenV2.adyenV2Checkout;
